<div class="wrapper" #controls>
  <div class="header-filler"></div>
  <div class="header-container">
    <ui-icon class="navigate-back-icon" faName="arrow-left" faStyle="light" (click)="navigateBack()">Close</ui-icon>
    @if (headerConfig(); as config) {
      <h2>{{ config.title }}</h2>
      <div class="wrapper-header-icon" [class.with-badge]="config.badge">
        <ui-icon
          [matBadge]="config.badge ? config.badge() : undefined"
          matBadgeSize="large"
          [faName]="config.icon"
          [faStyle]="config.iconStyle"
          [title]="config.iconTitle"
          [routerLink]="[config.link]">
        </ui-icon>
      </div>
    }
  </div>

  <div class="toggle-container">
    <p>Taschenlampe</p>
    <mat-slide-toggle (click)="toggleTorch()"></mat-slide-toggle>
  </div>

  <div class="toggle-container no-border">
    <p>Bestell-Modus</p>
    <mat-slide-toggle [checked]="orderMode()" (click)="toggleOrderMode()"></mat-slide-toggle>
  </div>

  @if (sightHidden() || loading()) {
    <div class="spinner">
      @if (loading()) {
        <ui-spinner></ui-spinner>
      }
      <ui-animated-success-error></ui-animated-success-error>
    </div>
  }

  <div #sight (touchmove)="resizeSight($event)" [hidden]="!sightEnabled() || sightHidden()" class="square">
    <ui-icon [rotate]="90" faStyle="solid" faName="up-right-and-down-left-from-center"></ui-icon>
  </div>
</div>
